import mixpanel from 'mixpanel-browser';

export const init = token => {
  mixpanel.init(token, { debug: true });
};

export const identify = user => {
  if (user) {
    mixpanel.identify(user.username);
    let data = {
      $name: user.username,
      $username: user.username,
      'Updated at': new Date(),
    };

    if (user.email) data['$email'] = user.email;
    if (user.mobile_no) data['$phone'] = user.mobile_no;

    mixpanel.people.set(data);
  }
};

export const trackPageView = source => {
  mixpanel.track(window.location.pathname + (source ? ` (${source})` : ''));
};

export const trackEvent = (eventName, eventData) => {
  mixpanel.track(eventName, eventData || {});
};

export const reset = () => {
  mixpanel.reset();
};
